import apiRequest from './apiRequest';

export type PostRenderCanvasFeedbackPayload = {
  sentiment: 'positive' | 'negative';
  comment?: string;
};

export default async function postRenderCanvasFeedback(
  projectID: string,
  body: PostRenderCanvasFeedbackPayload,
) {
  return await apiRequest(
    'mogen-orchestration',
    `/v2/projects/${projectID}/renderCanvas/feedback`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}
